import React from 'react';
import { SvgIconProps } from '@mui/material';

export const AsteriskIcon: React.FC<SvgIconProps> = (props) => (
    <svg
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M7.45113 6.15036V3.04126H6.51455V6.15038L3.62804 4.4036L3.55688 4.52117V5.45527L6.07833 6.9811L3.55688 8.50694V9.44103L3.62804 9.5586L6.51455 7.81182V10.9209H7.45113V7.81185L10.3376 9.5586L10.4088 9.44106V8.50697L7.88731 6.9811L10.4088 5.45524V4.52114L10.3376 4.4036L7.45113 6.15036Z"
            fill="currentColor"
        />
        <path
            d="M11.9538 2.04618C10.6395 0.73487 8.85832 -0.00107945 7.00169 1.18839e-06C5.14506 0.00108182 3.36478 0.739104 2.05194 2.05194C0.739105 3.36478 0.00108182 5.14506 1.18839e-06 7.00169C-0.00107945 8.85832 0.73487 10.6395 2.04618 11.9538C3.36054 13.2651 5.14168 14.0011 6.99831 14C8.85494 13.9989 10.6352 13.2609 11.9481 11.9481C13.2609 10.6352 13.9989 8.85494 14 6.99831C14.0011 5.14168 13.2651 3.36054 11.9538 2.04618ZM6.99999 13.0692C3.65344 13.0692 0.930828 10.3466 0.930828 7.00001C0.930828 3.65347 3.65344 0.930828 6.99999 0.930828C10.3465 0.930828 13.0692 3.65344 13.0692 7.00001C13.0692 10.3466 10.3466 13.0692 6.99999 13.0692Z"
            fill="currentColor"
        />
    </svg>
);

export default AsteriskIcon;
